import { useTranslation } from "react-i18next";
import { Shield } from "lucide-react";

export function AdminGatePlaceholder() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed py-10 text-center space-y-2">
      <Shield className="h-8 w-8 text-muted-foreground" />
      <p className="text-sm text-muted-foreground">{t("executive.adminOnly")}</p>
    </div>
  );
}
